module.exports = function (objectExport) {
  if (!objectExport) return

  if (!global.Intl) {
    require.ensure([
      'intl',
      'intl/locale-data/jsonp/pt-BR.js'
    ], function (require) {
      require('intl');
      require('intl/locale-data/jsonp/pt-BR.js');
      require('intl/locale-data/jsonp/en-US.js');
    });
  }

  objectExport.genericRenderTable = function (id, customOption, callback) {
    let options = {
      pagingType: "full_numbers",
      lengthMenu: [
        [10, 25, 50, -1],
        [10, 25, 50, "Todos"]
      ],
      order: [],
      responsive: true,
      language: {
        sEmptyTable: "Nenhum registro encontrado",
        sInfo: "Mostrando de _START_ até _END_ de _TOTAL_ registros",
        sInfoEmpty: "Mostrando 0 até 0 de 0 registros",
        sInfoFiltered: "(Filtrados de _MAX_ registros)",
        sInfoPostFix: "",
        sInfoThousands: ".",
        sLengthMenu: "_MENU_ resultados por página",
        sLoadingRecords: "Carregando...",
        sProcessing: "Processando...",
        sZeroRecords: "Nenhum registro encontrado",
        sSearch: "Pesquisar",
        oPaginate: {
          sNext: "Próximo",
          sPrevious: "Anterior",
          sFirst: "Primeiro",
          sLast: "Último"
        },
        oAria: {
          sSortAscending: ": Ordenar colunas de forma ascendente",
          sSortDescending: ": Ordenar colunas de forma descendente"
        },
        buttons: {
          pageLength: 'Mostrar %d Linhas'
        }
      },
      buttons: [],
      dom: '<"pull-left"f>tiB<"pull-right">pa<"clear">',
    }

    if (customOption != undefined) {
      customOption.forEach(i => {
        options[i.name] = i.value;
      });
    }
    setTimeout(function () {
      const table = $('#' + id).DataTable(options);

      setTimeout(function () {
        if (callback && typeof callback === 'function') callback(table);
        //document.location.href = '';
      }, 0);
    }, 0);
  }


  objectExport.genericCreateVueLocation = function (id) {
    $('#html-sd').append('<div id="' + id + '"></div>');
    return '#' + id;
  }

  objectExport.genericCreateTable = function (obj) {
    let headerTh = '';

    obj.tableHeaders.forEach(i => {
      headerTh += '<th>' + i + '</th>'
    });

    $('#' + obj.injectLocation).append(
      `
    <table id="`+ obj.tableId + `" class="table table-striped table-no-bordered table-hover ` + obj.tableClass + `" cellspacing="0" width="100%" style="width:100%">
      <thead>
        <tr>
          ` + headerTh + `
        </tr>
      </thead>
      <tbody>
        ` + obj.tableTr + `
      </tbody>
    </table>
  `
    );
  }

  objectExport.genericFormatCnpjCpf = function (arg) {
    if (arg.length == 11) {
      return genericFormatCpf(arg);
    } else if (arg.length == 14) {
      return genericFormatCnpj(arg);
    } else {
      return arg;
    }
  }

  objectExport.genericFormatCpf = function (v) {
    if (typeof v !== 'string') return '';

    v = v.replace(/\D/g, "");
    v = v.replace(/(\d{3})(\d)/, "$1.$2");
    v = v.replace(/(\d{3})(\d)/, "$1.$2");
    v = v.replace(/(\d{3})(\d{1,2})$/, "$1-$2");
    return v;
  }

  objectExport.genericFormatCnpj = function (v) {
    if (typeof v !== 'string') return '';

    v = v.replace(/\D/g, "");
    v = v.replace(/^(\d{2})(\d)/, "$1.$2");
    v = v.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3");
    v = v.replace(/\.(\d{3})(\d)/, ".$1/$2");
    v = v.replace(/(\d{4})(\d)/, "$1-$2");
    return v;
  }

  /* GENERIC CEP */
  objectExport.genericFormatCep = function (v) {
    if (typeof v !== 'string') return '';

    v = v.replace(/\D/g, "");
    v = v.replace(/^(\d{5})(\d)/, "$1-$2");
    return v;
  }

  /* GENERIC PHONE */
  objectExport.genericFormatPhone = function (v) {
    if (typeof v !== 'string') return '';

    v = v.replace(/\D/g, "");
    if (v.length == 11) {
      v = v.replace(/(\d{2})(\d)/, "($1) $2");
      v = v.replace(/(\d{5})(\d)/, "$1-$2");
    } else if (v.length == 10) {
      v = v.replace(/(\d{2})(\d)/, "($1) $2");
      v = v.replace(/(\d{4})(\d)/, "$1-$2");
    } else if (v.length == 9) {
      v = v.replace(/(\d{5})(\d)/, "$1-$2");
    } else if (v.length == 8) {
      v = v.replace(/(\d{4})(\d)/, "$1-$2");
    }
    return v;
  }

  objectExport.getParameterByName = function (name) {
    var match = RegExp('[?&]' + name + '=([^&]*)').exec(window.location.search);
    return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
  }

  /* GENERIC AJAX*/
  objectExport.genericAjax = function (type, url, headers, callback) {
    $.ajax({
      type: type,
      crossDomain: true,
      url: url,
      headers: headers,
      success: (data) => {
        if (_.get(data,'status') == 401
        || _.get(data,'status') == '#SESSION_NOTFOUND'
        || _.get(data,'status') == '#USER_TOKEN_NOTFOUND'
        || _.get(data,'status') == '#INVALID_TOKEN') {
          return brain.sessionError();
        }
        callback(data);
      },
      error: (data) => {
        console.log(data)
        console.log('OCORREU UM ERRO EM UMA REQUISIÇÃO AJAX');
        callback(data);
      }
    });
  }
}
